module.exports = __webpack_public_path__ + "static/media/delivery_failed.0ffdcd80.png";